import type { ApiPinflGetResponse } from '@/shared/types/api/pinfl';

/**
 * True when a form row counts toward the limit on top of the excluded-parcel
 * baseline. Unsaved rows (no server id) always count; saved rows the server
 * does not count (created before the usage window, e.g. last month or before
 * an admin reset) are skipped, so baseline + live total == server usage.
 */
export const isCountedInLimit = (
  limit: Pick<ApiPinflGetResponse, 'uncounted_product_ids'> | null | undefined,
  serverId?: string | null,
): boolean => !serverId || !(limit?.uncounted_product_ids ?? []).includes(serverId);
